import { render, staticRenderFns } from "./CooikeDiv.vue?vue&type=template&id=6740dd87&scoped=true"
import script from "./CooikeDiv.vue?vue&type=script&lang=js"
export * from "./CooikeDiv.vue?vue&type=script&lang=js"
import style0 from "./CooikeDiv.vue?vue&type=style&index=0&id=6740dd87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740dd87",
  null
  
)

export default component.exports